import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'
import type { PageProps } from '@/types'
export const pageUrl = '/[locale]/streambot/fundraising-events/[slug]/voting?token'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type VotingPageProps = PageProps<typeof pageUrl, { token?: string; preview?: 'true' | '' }>
